import useService from './useService';
import userInfo from '../lib/services/userInfo';
import { useEffect } from 'react';
import { redirect } from '../lib/Utils';

/**
 * ProxyAuth hook
 * @param resend
 */
export default function(resend?: number) {
  const { send, success, response } = useService(userInfo);
  const isLogged = success;

  useEffect(() => {
    send();
  }, [send, resend]);

  useEffect(() => {
    // auth proxy mode - redirect for url from backend if user already log in
    if (isLogged && response && response.body) {
      redirect('/crm-client');
    }
  }, [isLogged, response]);
  return {
    isLogged,
    response,
    send
  };
}
